import './kitStyles';
import React from 'react';

/**
 * WEB-3310 юнит 1 — полоса доли кита, эталон `Bar({ value, max = 1, tone =
 * 'accent', size = 'sm', label, title, width })`: доля 0…100 % в
 * `aria-valuenow` и ширине заливки; ноль — без заливки (`data-zero`). Числа
 * ставить рядом, не внутрь.
 */
export type BarTone = 'accent' | 'ok' | 'err' | 'muted' | 'rest';

export interface BarProps {
  value: number | null | undefined;
  max?: number;
  tone?: BarTone;
  size?: 'sm' | 'md';
  label?: string;
  title?: string;
  width?: number | string;
}

export function Bar({
  value,
  max = 1,
  tone = 'accent',
  size = 'sm',
  label,
  title,
  width,
}: BarProps): React.ReactElement {
  const p = Math.max(0, Math.min(100, max ? ((value || 0) / max) * 100 : 0));
  return (
    <span
      className={'kbar ' + size + ' ' + tone}
      style={width != null ? { width } : undefined}
      role="meter"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(p)}
      aria-label={label}
      title={title}
    >
      <i style={{ width: p + '%' }} data-zero={p > 0 ? undefined : ''} />
    </span>
  );
}
